import React, { useState } from 'react';
import '../../styles/quiz-base.css';
import './dataNascimento.css';
import Footer from '../../components/footer/Footer';

const API_BASE = process.env.REACT_APP_API_BASE;

const DataNascimento = ({ onSucesso }) => {
  const [data, setData] = useState('');
  const [erro, setErro] = useState('');
  const [enviando, setEnviando] = useState(false);

  const calcularIdade = (dataNascimento) => {
    const hoje = new Date();
    const nascimento = new Date(dataNascimento);

    let idade = hoje.getFullYear() - nascimento.getFullYear();
    const mes = hoje.getMonth() - nascimento.getMonth();

    if (mes < 0 || (mes === 0 && hoje.getDate() < nascimento.getDate())) {
      idade--;
    }

    return idade;
  };

  const handleEnviar = async () => {
    // 1️⃣ Data vazia ou inválida
    if (!data || isNaN(Date.parse(data))) {
      setErro('Informe uma data de nascimento válida.');
      return;
    }

    const hoje = new Date();
    const nascimento = new Date(data);

    // 2️⃣ Data no futuro
    if (nascimento > hoje) {
      setErro('Verifique se a data informada está correta.');
      return;
    }

    const idade = calcularIdade(data);

    // 3️⃣ Menor de 13 anos
    if (idade < 13) {
      setErro('Esse aplicativo é indicado para pessoas a partir de 13 anos.');
      return;
    }

    // 4️⃣ Idade absurda (ex: 100+ anos)
    if (idade > 80) {
      setErro('Verifique se a data informada está correta.');
      return;
    }

    setEnviando(true);
    setErro('');

    try {
      const resposta = await fetch(`${API_BASE}/salvar-etapa.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({
          campo: 'data_nascimento',
          valor: data
        })
      });

      const dados = await resposta.json();

      if (dados.status === 'sucesso') {
        onSucesso();
      } else {
        setErro(dados.mensagem || 'Erro ao salvar. Tente novamente.');
      }
    } catch (error) {
      setErro('Erro ao conectar com o servidor.');
    }

    setEnviando(false);
  };

  return (
    <div className="quiz-etapa">
      <img src="/assets/logo1.png" alt="Logo NutriFitMe" className="quiz-logo" />

      <div className="quiz-progresso">
        <div className="quiz-progresso-barra">
          <div
            className="quiz-progresso-preenchido"
            style={{ width: '28.5%' }}
          ></div>
        </div>
        <div className="quiz-progresso-texto">2 de 7</div>
      </div>

      <h2 className="quiz-pergunta">Qual a sua data de nascimento?</h2>
      <p className="quiz-texto-extra">
        Com isso conseguimos calcular sua idade e definir a estratégia ideal.
      </p>

      <input
        type="date"
        className="quiz-input"
        value={data}
        onChange={(e) => setData(e.target.value)}
      />

      {erro && <p className="quiz-erro">{erro}</p>}

      <button
        className={`quiz-botao ${data && !enviando ? 'ativo' : ''}`}
        onClick={handleEnviar}
        disabled={!data || enviando}
      >
        {enviando ? 'Enviando...' : 'Continuar'}
      </button>

      <div className="quiz-footer">
        <Footer />
      </div>
    </div>
  );
};

export default DataNascimento;
